/**
 * @file src/_modulos/prenota/tabela/layouts/config/hooks/useTableHelpers.ts
 * @description Funções auxiliares simples para a tabela
 *
 * Princípios aplicados:
 * - KISS: Funções simples e diretas
 * - YAGNI: Apenas o que é realmente necessário
 */

import { useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useTableStore, PRENOTAS_QUERY_KEY } from "@PN/tabela";

/* -------------------------------------------------------------------------- */
/* FUNÇÕES AUXILIARES                                                         */
/* -------------------------------------------------------------------------- */

/**
 * Determina quais filiais usar para estatísticas
 */
export function useFilialsForStats(
  selectedFilials: string[],
  accessibleFilialCodes: string[]
) {
  return useMemo(() => {
    return selectedFilials.length > 0 ? selectedFilials : accessibleFilialCodes;
  }, [selectedFilials, accessibleFilialCodes]);
}

/**
 * Hook para filtros rápidos
 */
export function useQuickFilter() {
  const { setFilter, setPageIndex } = useTableStore();
  const queryClient = useQueryClient();

  const handleQuickFilter = (
    field: string,
    value: string | number | boolean
  ) => {
    setFilter(field as any, value);
    setPageIndex(0);
    queryClient.invalidateQueries({ queryKey: PRENOTAS_QUERY_KEY });
  };

  return { handleQuickFilter };
}
